module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap",
    attrs: {
      "data-testid": "login-page"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 2),
      expression: "step === 2"
    }],
    staticClass: "otp-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "lg-title",
    attrs: {
      "data-testid": "login-title"
    }
  }, [(_vm.step === 1) ? _c('span', [_vm._v("What's your email or phone number?")]) : _c('span', [_vm._v("OTP Verification")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 1),
      expression: "step === 1"
    }]
  }, [_c('form', {
    staticClass: "form-mobx",
    attrs: {
      "data-testid": "login-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleContinue($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-shell",
    class: {
      'is-phone': _vm.isPhoneMode, 'is-focused': _vm.focused
    },
    attrs: {
      "data-testid": "input-shell"
    }
  }, [(_vm.isPhoneMode) ? _c('div', {
    staticClass: "country-select",
    attrs: {
      "data-testid": "country-select-wrapper"
    }
  }, [_c('button', {
    staticClass: "country-trigger",
    attrs: {
      "type": "button",
      "data-testid": "country-trigger",
      "aria-haspopup": "listbox",
      "aria-expanded": _vm.countryMenuOpen ? 'true' : 'false'
    },
    on: {
      "click": _vm.toggleCountryMenu
    }
  }, [_c('span', {
    staticClass: "flag",
    attrs: {
      "data-testid": "country-flag"
    }
  }, [_c('div', {
    class: 'iti-flag ' + _vm.selectedCountry.code
  })]), _vm._v(" "), _c('svg', {
    staticClass: "chev",
    class: {
      rot: _vm.countryMenuOpen
    },
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 7.5L10 12.5L15 7.5",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), (_vm.countryMenuOpen) ? _c('ul', {
    staticClass: "country-menu",
    attrs: {
      "role": "listbox",
      "data-testid": "country-menu"
    }
  }, [_c('li', {
    staticClass: "search-country"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countrySearch),
      expression: "countrySearch"
    }],
    ref: "countrySearch",
    attrs: {
      "type": "text",
      "placeholder": "Type your country.."
    },
    domProps: {
      "value": (_vm.countrySearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.countrySearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.countryList), function(c) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.countryFilter(c.name)),
        expression: "countryFilter(c.name)"
      }],
      key: c.code,
      staticClass: "country-item",
      class: {
        active: c.code === _vm.selectedCountry.code
      },
      attrs: {
        "role": "option",
        "aria-selected": c.code === _vm.selectedCountry.code ? 'true' : 'false',
        "data-testid": ("country-item-" + (c.code))
      },
      on: {
        "click": function($event) {
          _vm.selectCountry(c)
        }
      }
    }, [_c('div', {
      class: 'iti-flag ' + c.code
    }), _vm._v(" "), _c('span', {
      staticClass: "c-name"
    }, [_vm._v(_vm._s(_vm.cleanCountryName(c.name)))]), _vm._v(" "), _c('span', {
      staticClass: "c-dial"
    }, [_vm._v("+" + _vm._s(c.dialCode))])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isPhoneMode) ? _c('div', {
    staticClass: "country-select phone-code-txt"
  }, [_c('span', {
    staticClass: "dial",
    attrs: {
      "data-testid": "country-dial"
    }
  }, [_vm._v("+" + _vm._s(_vm.selectedCountry.dialCode))])]) : _vm._e(), _vm._v(" "), (_vm.isPhoneMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "theInput",
    staticClass: "text-input",
    attrs: {
      "autocomplete": "off",
      "spellcheck": "false",
      "data-testid": "login-input",
      "type": "tel",
      "inputmode": "tel",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.onInput],
      "keydown": _vm.onKeydown
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "theInput",
    staticClass: "text-input",
    attrs: {
      "autocomplete": "off",
      "spellcheck": "false",
      "data-testid": "login-input",
      "type": "text",
      "inputmode": "email",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.onInput],
      "keydown": _vm.onKeydown
    }
  })]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "mobx-error-box"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "continue-btn brand-bg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit,
      "data-testid": "continue-button"
    }
  }, [_vm._v("\n        Continue\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "or-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('searchForm.or')))])]), _vm._v(" "), _c('div', {
    staticClass: "corporate-login-signup"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.$t('searchForm.haveCorporate')) + "\n        "), _c('a', {
    staticClass: "next-line-mobile",
    on: {
      "click": _vm.loginSignup
    }
  }, [_vm._v(_vm._s(_vm.$t('searchForm.loginSignup')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 2),
      expression: "step === 2"
    }],
    staticClass: "verify-box"
  }, [_c('span', {
    staticClass: "vfy-label"
  }, [_vm._v("\n      We have sent the verification code to\n      "), (_vm.isPhoneMode) ? _c('b', [_vm._v("+" + _vm._s(_vm.selectedCountry.dialCode) + _vm._s(_vm.value))]) : _c('b', [_vm._v(_vm._s(_vm.value))])]), _vm._v(" "), _c('otp', {
    ref: "otpField",
    attrs: {
      "digit-count": 4,
      "auto-verify": true
    },
    on: {
      "complete": _vm.verifyCode
    },
    model: {
      value: (_vm.verificationCode),
      callback: function($$v) {
        _vm.verificationCode = $$v
      },
      expression: "verificationCode"
    }
  }), _vm._v(" "), _c('div', {
    class: ['resend-code', {
      '-enable': !_vm.resendCountdown
    }],
    on: {
      "click": _vm.resendCode
    }
  }, [_vm._v("\n      Resend Code\n      "), (_vm.resendCountdown) ? _c('span', [_vm._v("(" + _vm._s(_vm.resendCountdown) + "s)")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "continue-btn brand-bg",
    on: {
      "click": _vm.verifyCode
    }
  }, [_vm._v("\n      Confirm\n    ")])], 1), _vm._v(" "), _c('login-signup', {
    on: {
      "corporateAuthSuccess": _vm.corporateAuthSuccess
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6aba21f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aba21f2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/EmailMobileForm.vue
// module id = 2107
// module chunks = 0